import { render, staticRenderFns } from "./HelpLeaderboard.vue?vue&type=template&id=4aff2682&scoped=true&"
import script from "./HelpLeaderboard.vue?vue&type=script&lang=ts&"
export * from "./HelpLeaderboard.vue?vue&type=script&lang=ts&"
import style0 from "./HelpLeaderboard.vue?vue&type=style&index=0&id=4aff2682&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff2682",
  null
  
)

export default component.exports